var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingPhotoPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.09 52.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #99a7c9;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #f2f5fd;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    className: "cls-2",
    x: 2.04,
    y: 1.16,
    width: 59,
    height: 50,
    rx: 6,
    ry: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    className: "cls-1",
    d: "M41.89,40.52h-6.19c.28,0,.5-.22.5-.5v-5.1h1.03c.28,0,.5-.22.5-.5v-1.87c0-.28-.22-.5-.5-.5h-11.42c-.28,0-.5.22-.5.5v1.86c0,.28.22.5.5.5h1.06v5.1c0,.28.22.5.5.5h-6.19c-.28,0-.5-.22-.5-.5v-22.55h21.7v22.56c0,.28-.22.5-.5.5M31.03,34.91h-3.14v4.6h3.14v-4.6ZM35.2,34.91h-3.17v4.6h3.17v-4.6ZM26.32,33.9h10.41v-.86h-10.41v.86ZM27.31,23.9h-3.45c-.28,0-.5-.22-.5-.5v-4.55c0-.28.22-.5.5-.5h3.45c.28,0,.5.22.5.5v4.55c0,.28-.22.5-.5.5M24.36,22.89h2.44v-3.54h-2.44v3.54ZM39.2,23.9h-3.45c-.28,0-.5-.22-.5-.5v-4.55c0-.28.22-.5.5-.5h3.45c.28,0,.5.22.5.5v4.55c0,.28-.22.5-.5.5M36.26,22.89h2.44v-3.54h-2.44v3.54ZM33.27,23.9h-3.45c-.28,0-.5-.22-.5-.5v-4.55c0-.28.22-.5.5-.5h3.45c.28,0,.5.22.5.5v4.55c0,.28-.22.5-.5.5M30.32,22.89h2.44v-3.54h-2.44v3.54ZM27.3,30.99h-3.45c-.28,0-.5-.22-.5-.5v-4.55c0-.28.22-.5.5-.5h3.45c.28,0,.5.22.5.5v4.55c0,.28-.22.5-.5.5M24.36,29.98h2.44v-3.54h-2.44v3.54ZM39.2,30.99h-3.45c-.28,0-.5-.22-.5-.5v-4.55c0-.28.22-.5.5-.5h3.45c.28,0,.5.22.5.5v4.55c0,.28-.22.5-.5.5M36.26,29.98h2.44v-3.54h-2.44v3.54ZM33.26,30.99h-3.45c-.28,0-.5-.22-.5-.5v-4.55c0-.28.22-.5.5-.5h3.45c.28,0,.5.22.5.5v4.55c0,.28-.22.5-.5.5M30.32,29.98h2.44v-3.54h-2.44v3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    className: "cls-1",
    d: "M52.5,40.52H10.58c-.28,0-.5-.23-.5-.5s.23-.5.5-.5h41.92c.28,0,.5.23.5.5s-.23.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    className: "cls-1",
    d: "M44.03,16.46h-24.97c-.28,0-.5-.22-.5-.5v-2.65c0-.28.22-.5.5-.5h24.97c.28,0,.5.22.5.5v2.64c0,.28-.22.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    className: "cls-1",
    d: "M14.71,40.52c-.28,0-.5-.22-.5-.5v-4.88c0-.28.23-.5.5-.5s.5.23.5.5v4.88c0,.28-.22.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    className: "cls-1",
    d: "M17.68,31.17h-5.93c-.18,0-.34-.1-.43-.25-.1-.15-.1-.35,0-.5l2.94-5.15c.1-.15.27-.25.45-.25.18,0,.34.1.43.25l2.92,5.08c.08.09.13.21.13.33,0,.28-.22.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    className: "cls-1",
    d: "M17.68,33.73h-5.93c-.18,0-.34-.1-.43-.25-.1-.15-.1-.35,0-.5l1.48-2.57c.08-.16.25-.26.43-.25h2.97c.18,0,.34.09.43.25l1.43,2.49c.08.09.12.21.13.33,0,.28-.22.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    className: "cls-1",
    d: "M17.68,35.64h-5.93c-.18.01-.35-.09-.43-.25-.1-.15-.1-.35,0-.5l1.11-1.91c.09-.15.25-.25.43-.25h3.7c.18,0,.35.1.45.25l1.06,1.86c.08.08.12.19.13.3,0,.28-.22.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    className: "cls-1",
    d: "M48.38,40.52c-.28,0-.5-.22-.5-.5v-4.88c0-.28.23-.5.5-.5s.5.23.5.5v4.88c0,.28-.22.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    className: "cls-1",
    d: "M51.34,31.17h-5.93c-.18,0-.34-.1-.43-.25-.1-.15-.1-.35,0-.5l2.97-5.15c.13-.24.43-.32.66-.19.08.04.15.11.19.19l2.92,5.08c.08.09.13.21.13.33,0,.28-.22.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    className: "cls-1",
    d: "M51.34,33.73h-5.93c-.18,0-.34-.1-.43-.25-.1-.15-.1-.35,0-.5l1.48-2.57c.08-.16.25-.26.43-.25h2.97c.18,0,.34.09.43.25l1.43,2.49c.08.09.12.21.13.33,0,.28-.22.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    className: "cls-1",
    d: "M51.34,35.64h-5.93c-.18.01-.35-.09-.43-.25-.1-.15-.1-.35,0-.5l1.11-1.92c.09-.15.25-.25.43-.25h3.7c.18,0,.36.09.45.25l1.06,1.86c.08.08.12.19.13.3,0,.28-.22.5-.5.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingPhotoPlaceholder);
export default __webpack_public_path__ + "static/media/Building Photo Placeholder.9b2c5abd349e99527a73098700ea6106.svg";
export { ForwardRef as ReactComponent };